export const DEFAULT_FORMATS = 'zip';
export const DEFAULT_TITLE = 'Choose a file or drag & drop it here.';

export const DOCUMENT_TYPES = {
  'application/pdf': 'file-pdf',
  'image/jpeg': 'file-jpg',
  'image/png': 'file-png'
};

export const STATUSES = {
  uploading: 'Uploading...',
  uploaded: 'Completed',
  failed: 'Failed'
};

export const ICON_TYPES = {
  uploading: 'loader',
  uploaded: 'checkmark-circle',
  failed: 'new-info'
};

export const TRY_AGAIN_LABEL = 'Try again';

export const STEPS = {
  PRACTICE: 0,
  VENDOR: 1,
  FILES: 2,
  UPLOAD: 3,
  PROCCESS: 4
};

export const FILE_UPLOAD_STATUS = {
  INITIATED: 0,
  UPLOADING: 1,
  UPLOADED: 2,
  ERROR: 3
};

export const CHUNK_SIZE = 5 * 1024 * 1024;

export const initialBreadcrumbs = [
  { title: 'Select Practice', active: true, view: STEPS.PRACTICE },
  { title: 'Select Vendor', view: STEPS.VENDOR },
  { title: 'Select Files', view: STEPS.FILES },
  { title: 'Upload Files', view: STEPS.UPLOAD },
  { title: 'Process Files', view: STEPS.PROCCESS }
];
